// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
// ページコンポーネントをインポート (まだ存在しなくてもOK)
import HomeView from '../views/HomeView.vue'
import AboutView from '../views/AboutView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // このように書くと、Aboutページが初めてアクセスされたときにのみロードされる (遅延ロード)
    component: AboutView
    // または、上記HomeViewのように直接インポートしてもOK
    // component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router